import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SEOHead = ({ 
  title, 
  description, 
  keywords,
  image = 'https://gipsovinil.kz/og-image.jpg',
  type = 'website'
}) => {
  const location = useLocation();
  const baseUrl = 'https://gipsovinil.kz';
  const currentUrl = `${baseUrl}${location.pathname}`;

  useEffect(() => {
    // Update document title
    if (title) {
      document.title = `${title} | GIPSOVINIL.KZ`;
    }

    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription && description) {
      metaDescription.setAttribute('content', description);
    }

    // Update keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords && keywords) {
      metaKeywords.setAttribute('content', keywords);
    }

    // Update canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', currentUrl);
    }

    // Update Open Graph tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle && title) {
      ogTitle.setAttribute('content', `${title} | GIPSOVINIL.KZ`);
    }

    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription && description) {
      ogDescription.setAttribute('content', description);
    }

    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute('content', currentUrl);
    }

    const ogImage = document.querySelector('meta[property="og:image"]');
    if (ogImage && image) {
      ogImage.setAttribute('content', image);
    }

    const ogType = document.querySelector('meta[property="og:type"]');
    if (ogType) {
      ogType.setAttribute('content', type);
    }

    // Update Twitter tags
    const twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle && title) {
      twitterTitle.setAttribute('content', `${title} | GIPSOVINIL.KZ`);
    }

    const twitterDescription = document.querySelector('meta[name="twitter:description"]');
    if (twitterDescription && description) {
      twitterDescription.setAttribute('content', description);
    }

  }, [title, description, keywords, image, type, currentUrl]);

  return null;
};

// Predefined SEO configurations for pages
export const seoConfig = {
  home: {
    ru: {
      title: 'Гипсовиниловые панели Казахстан — Завод №1 в РК',
      description: 'GIPSOVINIL.KZ — первый завод гипсовиниловых панелей в Казахстане. Монтаж в 5 раз быстрее, 100% сухой монтаж, 15+ лет эксплуатации. Доставка по всему РК.',
      keywords: 'гипсовиниловые панели, гипсовинил, стеновые панели Казахстан, панели для стен Астана, быстрый монтаж'
    },
    kz: {
      title: 'Гипсвинил панельдері Қазақстан — ҚР-дағы №1 зауыт',
      description: 'GIPSOVINIL.KZ — Қазақстандағы гипсвинил панельдерінің алғашқы зауыты. Монтаж 5 есе жылдам, 100% құрғақ монтаж.',
      keywords: 'гипсвинил панельдері, қабырға панельдері, Астана, Қазақстан'
    },
    en: {
      title: 'Gypsum Vinyl Panels Kazakhstan — Factory #1',
      description: 'GIPSOVINIL.KZ — first gypsum vinyl panel factory in Kazakhstan. 5x faster installation, 100% dry mounting, 15+ years lifespan.',
      keywords: 'gypsum vinyl panels, wall panels Kazakhstan, Astana, fast installation'
    }
  },
  about: {
    ru: {
      title: 'О компании GIPSOVINIL — Первый завод в Казахстане',
      description: 'ТОО ГИПСОВИНИЛ — первый специализированный завод гипсовиниловых панелей в РК. Производственная мощность 1 млн м² в год. СЭЗ Астана.',
      keywords: 'о компании гипсовинил, завод гипсовиниловых панелей, производство Астана, СЭЗ'
    },
    kz: {
      title: 'Компания туралы — Қазақстандағы алғашқы зауыт',
      description: 'ГИПСОВИНИЛ ЖШС — ҚР-дағы гипсвинил панельдерінің алғашқы мамандандырылған зауыты.',
      keywords: 'компания туралы, гипсвинил зауыты, Астана'
    },
    en: {
      title: 'About GIPSOVINIL — First Factory in Kazakhstan',
      description: 'GIPSOVINIL LLP — first specialized gypsum vinyl panel factory in Kazakhstan. Production capacity 1 million m² per year.',
      keywords: 'about gipsovinil, panel factory, Astana production'
    }
  },
  catalog: {
    ru: {
      title: 'Каталог гипсовиниловых панелей — Цены и характеристики',
      description: 'Каталог гипсовиниловых панелей GIPSOVINIL: ГКЛ, ГКЛВ, СМЛ панели. Декоры, цвета, размеры. Цены от производителя. Доставка по Казахстану.',
      keywords: 'каталог панелей, гипсовиниловые панели цена, ГКЛ панели, ГКЛВ, СМЛ панели, декоры'
    },
    kz: {
      title: 'Гипсвинил панельдерінің каталогы — Бағалар',
      description: 'GIPSOVINIL гипсвинил панельдерінің каталогы. Өндірушіден бағалар.',
      keywords: 'панельдер каталогы, бағалар, ГКЛ, ГКЛВ, СМЛ'
    },
    en: {
      title: 'Gypsum Vinyl Panels Catalog — Prices',
      description: 'GIPSOVINIL panels catalog: GKL, GKLV, SML panels. Decors, colors, sizes. Factory prices.',
      keywords: 'panels catalog, prices, GKL panels, decors'
    }
  },
  installation: {
    ru: {
      title: 'Монтаж гипсовиниловых панелей — Инструкции и видео',
      description: 'Инструкции по монтажу гипсовиниловых панелей GIPSOVINIL. Видео-руководства, технические альбомы, бесплатный шеф-монтаж.',
      keywords: 'монтаж панелей, установка гипсовинила, инструкция, шеф-монтаж'
    },
    kz: {
      title: 'Гипсвинил панельдерін монтаждау — Нұсқаулық',
      description: 'GIPSOVINIL панельдерін монтаждау бойынша нұсқаулық. Видео-нұсқаулар.',
      keywords: 'монтаж, орнату, нұсқаулық'
    },
    en: {
      title: 'Panel Installation — Instructions and Videos',
      description: 'GIPSOVINIL panel installation instructions. Video guides, technical albums, free supervision.',
      keywords: 'panel installation, mounting guide, instructions'
    }
  },
  certificates: {
    ru: {
      title: 'Сертификаты качества — GIPSOVINIL.KZ',
      description: 'Сертификаты качества гипсовиниловых панелей GIPSOVINIL. СТ KZ, заключения СЭС, пожарные сертификаты, класс Г1.',
      keywords: 'сертификаты, СТ KZ, пожарный сертификат, класс Г1, СЭС'
    },
    kz: {
      title: 'Сапа сертификаттары — GIPSOVINIL.KZ',
      description: 'GIPSOVINIL гипсвинил панельдерінің сапа сертификаттары.',
      keywords: 'сертификаттар, СТ KZ, сапа'
    },
    en: {
      title: 'Quality Certificates — GIPSOVINIL.KZ',
      description: 'GIPSOVINIL quality certificates. ST KZ, SES approvals, fire certificates, G1 class.',
      keywords: 'certificates, quality, ST KZ, fire certificate'
    }
  },
  contact: {
    ru: {
      title: 'Контакты GIPSOVINIL — Адрес, телефон, карта',
      description: 'Контакты завода GIPSOVINIL: адрес производства в СЭЗ Астана, шоурум, телефоны отдела продаж. Карта проезда.',
      keywords: 'контакты гипсовинил, адрес завода, телефон, Астана, шоурум'
    },
    kz: {
      title: 'Байланыс — GIPSOVINIL',
      description: 'GIPSOVINIL зауытының байланыс ақпараты. Мекенжай, телефон, карта.',
      keywords: 'байланыс, мекенжай, телефон, Астана'
    },
    en: {
      title: 'Contact GIPSOVINIL — Address, Phone, Map',
      description: 'GIPSOVINIL factory contacts: production address in Astana SEZ, showroom, sales phones.',
      keywords: 'contacts, address, phone, Astana, showroom'
    }
  }
};

export default SEOHead;
